import React from "react";

export default function UserGuideTileExploreIcon({ size = 47 }) {
  const gid = React.useId().replace(/:/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={gid}
          x1="0"
          y1="0"
          x2="46.75"
          y2="46.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7C28" />
          <stop offset="1" stopColor="#FF839A" />
        </linearGradient>
      </defs>
      <rect width="46.75" height="46.75" rx="23.375" fill={`url(#${gid})`} />
      <path
        d="M17.3434 29.4075C21.2237 28.9954 24.9733 28.9733 26.75 27C28.5267 25.0267 29.1852 22.0164 29.4075 17.3434C29.4075 17.3434 22.4778 16.9706 19.7242 19.7242C16.9706 22.4778 17.3434 29.4075 17.3434 29.4075ZM23.3709 25.0494C22.9047 25.0494 22.5099 24.8862 22.1866 24.5598C21.8632 24.2334 21.7016 23.8371 21.7016 23.3709C21.7016 22.9047 21.8648 22.5099 22.1911 22.1866C22.5175 21.8632 22.9138 21.7016 23.38 21.7016C23.8463 21.7016 24.2411 21.8648 24.5644 22.1911C24.8877 22.5175 25.0494 22.9138 25.0494 23.38C25.0494 23.8463 24.8862 24.2411 24.5598 24.5644C24.2334 24.8877 23.8371 25.0494 23.3709 25.0494ZM23.3755 37.7861C21.3698 37.7861 19.4917 37.4084 17.7412 36.6531C15.9907 35.8978 14.468 34.8726 13.1732 33.5778C11.8783 32.2829 10.8532 30.7602 10.0979 29.0098C9.34251 27.2593 8.96484 25.3812 8.96484 23.3755C8.96484 21.3698 9.34251 19.4917 10.0979 17.7412C10.8532 15.9907 11.8783 14.468 13.1732 13.1732C14.468 11.8783 15.9907 10.8532 17.7412 10.0979C19.4917 9.34251 21.3698 8.96484 23.3755 8.96484C25.3812 8.96484 27.2593 9.34251 29.0098 10.0979C30.7602 10.8532 32.2829 11.8783 33.5778 13.1732C34.8726 14.468 35.8978 15.9907 36.6531 17.7412C37.4084 19.4917 37.7861 21.3698 37.7861 23.3755C37.7861 25.3812 37.4084 27.2593 36.6531 29.0098C35.8978 30.7602 34.8726 32.2829 33.5778 33.5778C32.2829 34.8726 30.7602 35.8978 29.0098 36.6531C27.2593 37.4084 25.3812 37.7861 23.3755 37.7861Z"
        fill="white"
      />
    </svg>
  );
}
